import React, { useState } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ActionsButton, BasicModal, DateCell, StatusCell, PaginationTable } from 'common/components';
import { EditIcon, ReloadIcon } from 'common';
import { CrossIcon } from 'common/icons';
import TokensForm from '../TokensForm';
import { withTheme } from '../../../../common/styling/theme';
import { updateApiToken } from '../../_redux';

const TokensTable = ({ data, loading, params, location, history, getList, updateApiToken }) => {
  const search = { ...queryString.parse(location.search) };

  const [isOpen, setIsOpen] = useState(false);
  const [selectedToken, setSelectedToken] = useState(null);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  /* eslint-disable */
  const columns = [
    {
      Header: 'justName',
      Cell: ({
        row: {
          original: { title },
        },
      }) => <span>{title}</span>,
      isPreviewCell: true,
    },
    {
      Header: 'expiringDate',
      Cell: ({
        row: {
          original: { expires },
        },
      }) => (expires ? <DateCell value={expires} hideTime /> : <span>---</span>),
    },
    {
      Header: 'justStatus',
      Cell: ({
        row: {
          original: { isActive, isExpired },
        },
      }) => <StatusCell statusCode={isExpired ? 'expired' : isActive ? 'active' : 'inactive'} />,
    },
    {
      accessor: 'action',
      Header: () => null,
      Cell: ({
        row: {
          original: { id, title, expires, isActive, isExpired },
        },
      }) => (
        <div className="TokensTable__actions">
          <ActionsButton
            onClickFunc={() => {
              setSelectedToken({ id, title, expires });
              toggleModal();
            }}>
            <EditIcon />
          </ActionsButton>
          <ActionsButton
            onClickFunc={() => {
              updateApiToken({ tokenId: id, search, isActive: !isActive });
            }}>
            {!isExpired && (isActive ? <CrossIcon /> : <ReloadIcon />)}
          </ActionsButton>
        </div>
      ),
    },
  ];
  /* eslint-enable */

  return (
    <div>
      <PaginationTable
        data={data}
        columns={columns}
        loading={loading}
        getList={getList}
        location={location}
        history={history}
        params={params}
        isNewTable
        noResponsive
      />

      <BasicModal
        overlayClassName="ApiTokens__modal"
        isOpen={isOpen}
        captionId="editApiToken"
        onRequestClose={toggleModal}>
        <TokensForm
          initialValues={selectedToken}
          isUpdateForm
          tokenId={selectedToken?.id}
          onSubmitSuccess={toggleModal}
        />
      </BasicModal>
    </div>
  );
};

TokensTable.propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  params: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  getList: PropTypes.func.isRequired,
  updateApiToken: PropTypes.func.isRequired,
};

export default compose(
  connect(() => ({}), {
    updateApiToken: (tokenId, payload) => updateApiToken.request(tokenId, payload),
  }),
  withTheme()
)(TokensTable);

export { TokensTable };
